import {
  NavigationHintConfiguration,
  navigationHintExtension,
} from '@interhyp/platform-navigation';
import { matchPath } from '@interhyp/platform-router';
import React, { PropsWithChildren, useMemo } from 'react';

import styles from './MobileNavHint.module.scss';
import { LocalDefinedRoute } from '../../../views/secure/mortgage/hooks/useMortgageContextNavigation';

export function MobileNavHint({
  children,
  mainNavigation,
}: PropsWithChildren<{
  mainNavigation: LocalDefinedRoute[];
}>): React.JSX.Element {
  const hints = navigationHintExtension.useExtensions();

  const filteredHints = useMemo(() => {
    return hints.filter(hint => {
      return mainNavigation.some(nav => {
        return matchPath(nav.path, {
          path: hint.context ? `/${hint.context}/:id${hint.path}` : hint.path,
          exact: hint.exact,
        });
      });
    });
  }, [hints, mainNavigation]);

  return (
    <div className={styles.navigationHintContainer}>
      {children}

      {filteredHints.map((hintConfig, index) => (
        <Hint config={hintConfig} key={`${hintConfig.path}_${index}`} />
      ))}
    </div>
  );
}

function Hint({ config }: { config: NavigationHintConfiguration }) {
  const showHint = config.useHint();

  if (
    !showHint ||
    (showHint.type === 'COUNTER' && showHint.count === 0) ||
    (showHint.type === 'SIMPLE' && !showHint.active)
  ) {
    return null;
  }

  return <span className={styles.hint} />;
}
